import { render, staticRenderFns } from "./ProductDetailHeader.vue?vue&type=template&id=0e84dd2c&scoped=true"
import script from "./ProductDetailHeader.vue?vue&type=script&lang=js"
export * from "./ProductDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailHeader.vue?vue&type=style&index=0&id=0e84dd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e84dd2c",
  null
  
)

export default component.exports